const markdownPreviewLength = 1400;
const markdownCache = new Map<string, Promise<string>>();

function sanitizeMarkdownHtml(html: string): string {
  return html
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/\son[a-z]+\s*=\s*(['"]).*?\1/gi, '')
    .replace(/\s(href|src)\s*=\s*(['"])\s*javascript:.*?\2/gi, ' $1="#"');
}

async function parseMarkdownSummary(markdown: string): Promise<string> {
  const {Renderer, marked} = await import('marked');
  const renderer = new Renderer();

  renderer.html = () => '';
  renderer.image = () => '';

  const html = marked(markdown, {
    async: false,
    breaks: false,
    gfm: true,
    renderer
  });

  return sanitizeMarkdownHtml(html);
}

export function renderMarkdownSummary(markdownText: string): Promise<string> {
  const markdown = markdownText.slice(0, markdownPreviewLength);
  const cachedMarkdown = markdownCache.get(markdown);

  if (cachedMarkdown) {
    return cachedMarkdown;
  }

  const parsedMarkdown = parseMarkdownSummary(markdown);

  markdownCache.set(markdown, parsedMarkdown);

  return parsedMarkdown;
}
